import React, { useContext, useEffect, useState } from "react";
import {
  EnrichementTemplate,
  IntegrationTemplate,
  LinkedinTemplate,
} from "../../../common/Templates/Templates";
import { Col } from "react-bootstrap";
import TemplateSettings from "../../../common/Templates/TemplateSettings";
import {
  getWorkflow,
  getWorkflows,
} from "../../../../../services/api/workflows.api";
import { PreLoader } from "../../../../../components";
import { WorkflowContext } from "../../../store/workflow.store";
import actions from "../../../store/workflow.actions";

export default function CurrentWorkflow({
  workflow,
  navToggle,
  profile,
  organizationCredits,
}) {
  const [blockOptions, setSettingsOptions] = useState(false);
  const [isBlockActive, setBlockActivation] = useState(false);
  const [selectedWorkflow, selectWorkflow] = useState(null);
  const { state, dispatch } = useContext(WorkflowContext);

  const handleRefreshAndCloseSettings = (save) => {
    if (save) return setSettingsOptions(false);
    getWorkflow(workflow._id).then(({ data, statusCode }) => {
      if (statusCode == 200) {
        dispatch({ type: actions.SELECTED_TEMPLATE, payload: data.workflow });
      }
    });
    setSettingsOptions(false);
  };
  const SELECTED_TEMPLATE = {
    linkedin: (
      <LinkedinTemplate
        blockOptions={blockOptions}
        handleSettingsToggle={(options) => setSettingsOptions(options)}
        closeSettingsToggle={handleRefreshAndCloseSettings}
        template={state.selectedTemplate}
        activeBlockId={blockOptions.id}
        setBlockActivation={setBlockActivation}
        isBlockActive={isBlockActive}
      />
    ),
    enrichment: (
      <EnrichementTemplate
        blockOptions={blockOptions}
        handleSettingsToggle={(options) => setSettingsOptions(options)}
        template={state.selectedTemplate}
        activeBlockId={blockOptions.id}
        closeSettingsToggle={handleRefreshAndCloseSettings}
      />
    ),
    integration: (
      <IntegrationTemplate
        blockOptions={blockOptions}
        handleSettingsToggle={(options) => setSettingsOptions(options)}
        template={state.selectedTemplate}
        activeBlockId={blockOptions.id}
        closeSettingsToggle={handleRefreshAndCloseSettings}
      />
    ),
  };
  if (!state.selectedTemplate) {
    return <PreLoader />;
  }
  return (
    <div id="workflow_tab" className="tab-pane fade active show">
      <Col md={"12"} className={"content-wrap " + (navToggle ? "expand" : "")}>
        <WorkflowTreeWrapper>
          {/*
        <MenuBar createWorkflow={handleCreateWorkflow} />
*/}
          <div className="create-workflow-outer">
            <div className="create-workflow-tree-block ">
              <div className="create-inner-tree-block">
                {state.selectedTemplate.type == "linkedin" && (
                  <span
                    className={"beta-badge"}
                    style={{
                      position: "absolute",
                      top: 10,
                      left: 10,
                      width: "max-content",
                      fontSize: 14,
                      zIndex: 100,
                    }}
                  >
                    BETA
                  </span>
                )}
                {/*
                <ZoomButtons />
*/}
                {SELECTED_TEMPLATE[state.selectedTemplate.type]}
              </div>
              <TemplateSettings
                handleSettingsToggle={handleRefreshAndCloseSettings}
                blockOptions={blockOptions}
                profile={profile}
                organizationCredits={organizationCredits}
              />
            </div>
          </div>
        </WorkflowTreeWrapper>
      </Col>
    </div>
  );
}

function ZoomButtons() {
  return (
    <>
      <div className="workflow-zoom-block">
        <a href="#" className="btn zoom-out">
          <img src="/assets/images/ic_minus.svg" alt="" />
        </a>
        <span className="zoom-content">100%</span>
        <a href="#" className="btn zoom-in">
          <img src="/assets/images/ic_add.svg" alt="" />
        </a>
      </div>

      <div className="expend-btn">
        <img src="/assets/images/ic_fullscreen.svg" alt="" />
      </div>
    </>
  );
}

function WorkflowTreeWrapper({ children }) {
  return (
    <div className="content-block">
      <div className="inner-content-wrap">
        <div className="create-workflow-container">{children}</div>
      </div>
    </div>
  );
}
